import React, { ElementRef, ReactNode, useRef } from 'react';

import { useClickOutside } from './hooks/useClickOutside';
import { ToggleProvider, useToggle } from './hooks/useToggle';

interface DropdownProps {
    onClick?: () => void;
    children: ReactNode;
}

interface DropdownItemProps {
    onClick: () => void;
    children: ReactNode;
}

export const Dropdown = ({ children }: DropdownProps) => {
    return <ToggleProvider>{children}</ToggleProvider>;
};

/* Button */
const DropdownButton = ({ onClick, children }: DropdownProps) => {
    const { on, toggle } = useToggle();
    const container = useRef<ElementRef<'div'>>(null);
    useClickOutside(container, on, toggle);

    const handleClick = () => {
        toggle();
        if (onClick) {
            onClick();
        }
    };

    return (
        <div ref={container}>
            <button onClick={handleClick}>{children}</button>
        </div>
    );
};
Dropdown.Button = DropdownButton;

/* Menu */
const DropdownMenu = ({ children }: DropdownProps) => {
    const { on: showMenu } = useToggle();
    return (
        <div
            className={`${
                showMenu
                    ? 'opacity-100 translate-y-0 pointer-events-auto'
                    : 'opacity-0 translate-y-3 pointer-events-none'
            } border-box border-2 border-green-200 transform transition-all ease-in-out duration-500 absolute right-0 mt-2 w-56 rounded-lg overflow-hidden bg-white shadow-lg`}
            role="menu"
            aria-orientation="vertical"
        >
            {children}
        </div>
    );
};
Dropdown.Menu = DropdownMenu;

/* Item */
export const DropdownItem = ({ onClick, children }: DropdownItemProps) => {
    return (
        <button
            onClick={onClick}
            className="w-full font-semibold py-3 px-4 transition-all duration-150 ease-in-out hover:bg-green-100 text-black hover:text-green-500 hover:opacity-100 text-left"
            role="menuitem"
        >
            {children}
        </button>
    );
};
Dropdown.Item = DropdownItem;
